import { render, staticRenderFns } from "./NmtSidebarProfile.vue?vue&type=template&id=199ecd59&scoped=true&"
import script from "./NmtSidebarProfile.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199ecd59",
  null
  
)

export default component.exports